import * as React from "react";
import { cn } from "../../lib/utils";
import { ClassValue } from "clsx";

type Variant = "default" | "active" | "muted" | "ingredient";

// @tailwind
const variantClasses: Record<Variant, ClassValue> = {
  default: "bg-surface text-ink border border-line",
  active: "bg-gold/15 text-gold border border-gold",
  muted: "bg-surface text-ink-muted border border-line",
  ingredient: "bg-teal/10 text-ink-muted border border-line",
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = "default", ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center gap-1 rounded-pill px-2.5 py-0.5 text-xs font-medium transition",
        variantClasses[variant],
        className,
      )}
      {...props}
    />
  ),
);
Badge.displayName = "Badge";
